export const STICKY_LEFT_PANEL = 'stickyLeftPanel';
